import { render, staticRenderFns } from "./Validation.vue?vue&type=template&id=75352270&"
import script from "./Validation.vue?vue&type=script&lang=js&"
export * from "./Validation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Validation.vue?vue&type=custom&index=0&blockType=link&href=https%3A%2F%2Ffonts.googleapis.com%2Fcss2%3Ffamily%3DMontserrat%3Awght%40800%26display%3Dswap&rel=stylesheet"
if (typeof block0 === 'function') block0(component)

export default component.exports